export type AgingBucket = {
  name: string;
  value: number;
  color: string;
};

import { AGING_BUCKET_COLORS, agingColorFor } from "./receivablesChartTokens";

/**
 * Aging colors come from the validated scale in `receivablesChartTokens`.
 * The previous ramp (green → yellow → orange → orange → red) failed the
 * palette checks outright: lightness was not monotone, the two oranges were
 * 0.059 apart, and the yellow measured 1.92:1 against white.
 */
export const AGING_COLORS: Record<string, string> = AGING_BUCKET_COLORS;

/**
 * Aging bucket display name -> the filter value the receivables table uses.
 * Both spellings of the 1-30 bucket appear across API responses.
 */
const AGING_FILTER_VALUE_BY_NAME: Record<string, string> = {
  Current: "current",
  "0-30 days": "0_30",
  "1-30 days": "0_30",
  "31-60 days": "31_60",
  "61-90 days": "61_90",
  "90+ days": "90_plus",
  "91 and Over": "90_plus",
};

/** Filter value for a bucket label, or null when it isn't a known bucket. */
export function agingFilterValueFor(bucketName: string): string | null {
  return AGING_FILTER_VALUE_BY_NAME[bucketName] ?? null;
}

export function mapApiAgingBuckets(
  buckets: Array<{ name: string; amount: number }>,
): AgingBucket[] {
  return buckets.map((bucket) => ({
    name: bucket.name,
    value: bucket.amount,
    color: agingColorFor(bucket.name),
  }));
}
